import { useNavigate, useLocation } from "react-router-dom";
import Button from "@/components/Button/Button";
import Hands from "@/components/SVGComponents/Hands";
import Incognito from "@/components/SVGComponents/Incognito";
import Dining from "@/components/SVGComponents/Dining";
import BackgroundTexture from "@/assets/svg/backgroudTextureSvg";
import routes from "@/routes/routes";
import styles from "./HowItWorks.module.scss";
import ConversationIcon from "@/components/SVGComponents/ConversationIcon";

type HowItWorksLocationState = {
  eventId?: number | string;
};

const HOW_IT_WORKS_STEPS = [
  {
    icon: Hands,
    copy: "We match you with another founder",
  },
  {
    icon: Incognito,
    copy: "Details stay hidden until dinner day",
  },
  {
    icon: Dining,
    copy: "You meet over a curated dinner",
  },
  {
    icon:  ConversationIcon,
    copy: "Leave with real context and stronger connections",
  },
] as const;

const HowItWorks = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventId } = (location.state as HowItWorksLocationState) || {};

  const handleContinue = () => {
    navigate(routes.privateRoutes.MEMBERSHIP.path, {
      state: eventId ? { eventId } : undefined,
    });
  };

  return (
    <section aria-labelledby="how-it-works-title" className={styles.page}>
      <BackgroundTexture
        aria-hidden="true"
        className={styles.backgroundTextureTop}
      />
      <BackgroundTexture
        aria-hidden="true"
        className={styles.backgroundTextureBottom}
      />

      <div className={styles.content}>
        <div className={styles.main}>
          <img alt="BFC" className={styles.logo} src="/BFClogo.png" />

          <h1 className={styles.title} id="how-it-works-title">
            Here&apos;s How BFC Works
          </h1>

          <ol className={styles.steps}>
            {HOW_IT_WORKS_STEPS.map(({ icon: Icon, copy }) => (
              <li key={copy} className={styles.step}>
                <div className={styles.iconWrap}>
                  <Icon aria-hidden="true" className={styles.icon} />
                </div>
                <p className={styles.stepCopy}>{copy}</p>
              </li>
            ))}
          </ol>
        </div>

        <Button
          className={styles.continueButton}
          onClick={handleContinue}
          type="button"
        >
          Continue
        </Button>
      </div>
    </section>
  );
};

export default HowItWorks;
